// extracted by mini-css-extract-plugin
module.exports = {"wrap":"BlockTextAreaGray_wrap__vIhOr","wrap-title":"BlockTextAreaGray_wrap-title__f9egG","wrap-text":"BlockTextAreaGray_wrap-text__o8HGz"};